module.exports = __webpack_public_path__ + "static/media/2x2.190cb231.svg";